export default import.meta.ROLLDOWN_FILE_URL_u3hzV$XOpaPyVgNN09EB7Q